export interface PeriodOption {
  value: string;
  label: string;
}

/** Пресеты для BalanceCard (заработок) — с текущим календарным днём */
export const EARNINGS_PERIOD_PRESETS: PeriodOption[] = [
  { value: "24h", label: "Сегодня" },
  { value: "7d", label: "7 дней" },
  { value: "30d", label: "Месяц" },
  { value: "90d", label: "90 дней" },
];

/** Пресеты для StatsListView — без текущего дня */
export const STATS_PERIOD_PRESETS: PeriodOption[] = [
  { value: "7d", label: "7 дней" },
  { value: "30d", label: "Месяц" },
  { value: "90d", label: "90 дней" },
];

/** @deprecated Use EARNINGS_PERIOD_PRESETS or STATS_PERIOD_PRESETS */
export const PERIOD_PRESETS = EARNINGS_PERIOD_PRESETS;

export type PeriodValue = (typeof EARNINGS_PERIOD_PRESETS)[number]["value"];
